import profile from "../profile.jpeg";

function Home() {
  return (
    <div className="container">

      <img 
  src={profile} 
  alt="profile" 
  style={{
    width: "120px",
    height: "150px",
    borderRadius: "50%",   // ✅ makes it circular
    objectFit: "cover"
  }}
/>

      <h1>K. Venkata Subba Rao</h1>
      <h3 className="tagline">
        Artificial Intelligence Student | Aspiring Machine Learning Engineer
      </h3>

      <section>
        <h2>About Me</h2>
        <p>
          I am an undergraduate student in Artificial Intelligence at Mahindra University, 
          with strong interests in Machine Learning, Natural Language Processing, and Generative AI. 
          I focus on building data-driven solutions to real-world problems.
        </p>
      </section>

      <section>
        <h2>Research Interests</h2>
        <p>
          Artificial Intelligence, Machine Learning, NLP, Generative AI, Quantum Computing
        </p>
      </section>

     <section>
  <h2>Skills</h2>
  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
    <li>Languages: Python, C, JavaScript, React, HTML, CSS, SQL</li>
    <li>Tools: MATLAB, Flutter, MS Excel, PowerPoint</li>
    <li>Core Areas: AI, Machine Learning, NLP, Data Structures</li>
  </ul>
</section>

      <section>
        <h2>Contact</h2>
        <p>Email: kvenkatasubbarao526@gmail.com</p>
        <p>Phone: +91 7901522599</p>
      </section>

    </div>
  );
}

export default Home;